import type { ReactNode } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router";
import { Layout } from "./components/Layout";
import { Spinner } from "./components/ui";
import { useSession } from "./lib/session";
import { Admin } from "./pages/Admin";
import { ContractView, EditContract, NewContract } from "./pages/ContractPages";
import { Contracts } from "./pages/Contracts";
import { Dashboard } from "./pages/Dashboard";
import { Inbox, InboxItemPage } from "./pages/Inbox";
import { InboxLink } from "./pages/InboxLink";
import { Settings } from "./pages/Settings";
import { SignIn, Verify } from "./pages/SignIn";

function Protected({ children }: { children: ReactNode }) {
  const { me, loading } = useSession();
  const location = useLocation();
  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (!me) return <Navigate to={`/signin?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  return <Layout>{children}</Layout>;
}

export function App() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route path="/auth/verify" element={<Verify />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/contracts" element={<Protected><Contracts /></Protected>} />
      <Route path="/contracts/new" element={<Protected><NewContract /></Protected>} />
      <Route path="/contracts/:id" element={<Protected><ContractView /></Protected>} />
      <Route path="/contracts/:id/edit" element={<Protected><EditContract /></Protected>} />
      <Route path="/inbox" element={<Protected><Inbox /></Protected>} />
      <Route path="/inbox/:id" element={<Protected><InboxItemPage /></Protected>} />
      {/* The reply email's links work without signing in. */}
      <Route path="/inbox/link" element={<InboxLink />} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Protected><div className="space-y-2"><h1 className="text-xl font-semibold tracking-tight">Page not found</h1><a className="font-medium text-accent-fg underline underline-offset-2" href="/">Go to the dashboard</a></div></Protected>} />
    </Routes>
  );
}
